import VueScrollmagic from 'vue-scrollmagic';
import Vue from 'vue';
Vue.use(VueScrollmagic);
